import { useRef } from 'react'
import { Translate } from 'react-redux-i18n'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import { LegendItem } from '../../../../../common/chart/legend/LegendItem'
import { Element } from '../../../../../common/html/element'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../helpers/common'
import { convertData, isInValidValue } from '../../../../../helpers/value'
import { getStyleHeightContainer } from '../../helper'
import classes from '../../index.module.scss'

const filterGroup = (checkboxs, checked, group) => {
  return checkboxs.filter(
    (item) => item.group === group && checked.includes(item.value),
  )
}

const filterCheckGroup = (checkboxs, group) => {
  return checkboxs.filter((item) => item.group === group)
}

const Trend = ({
  data,
  indicatorById,
  isCheckbox,
  checkboxs,
  checked,
  setChecked,
  isDynamicReport,
}) => {
  const chartId = useRef(getUnique())

  const {
    formatedUnit,
    getExchangeRate,
    multiplier,
    formatValueWithUnit,
    decimalLength,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)

  const dataConvert = convertData(
    data.map((item) => {
      return Object.keys(item).reduce(
        (prev, curr) => ({
          ...prev,
          [curr]:
            typeof item[curr] === 'number' && item[curr] < 0
              ? Math.abs(item[curr])
              : item[curr],
        }),
        {},
      )
    }),
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
  )

  const group1 = filterGroup(checkboxs, checked, 1)
  const group2 = filterGroup(checkboxs, checked, 2)
  const group3 = filterGroup(checkboxs, checked, 3)
  const totalGroup = [group1, group2, group3]
  const groupCheck1 = filterCheckGroup(checkboxs, 1)
  const groupCheck2 = filterCheckGroup(checkboxs, 2)
  const groupCheck3 = filterCheckGroup(checkboxs, 3)
  const totalGroupCheck = [groupCheck1, groupCheck2, groupCheck3]

  const renderGroupName = (idxGroup) => {
    switch (idxGroup) {
      case 1:
        return <Translate value="financialAnalysis.INCOME" />
      case 2:
        return <Translate value="financialAnalysis.EXPENSES" />
      case 3:
        return <>&nbsp;</>
      default:
        return ''
    }
  }

  const isNoData = !data?.length

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="dFlex"
    >
      <div className="flexColumn w60 h100">
        <Element className={classes.pdb6} style={{ color: '#9C9C9C' }}>
          {formatedUnit}
        </Element>
        <ChartContainer
          chartId={chartId.current}
          data={dataConvert}
          margin={{
            top: 10,
            bottom: 0,
            left: isDynamicReport ? 16 : 0,
            right: 0,
          }}
          width="100%"
          height="100%"
          xAxis={[{ dataKey: 'year' }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: totalGroup.map((group) =>
                group.map((item) => item.value),
              ),
              isStackedBar: true,
              isGroupBar: true,
              decimalLength,
            },
          ]}
          tooltip={{
            schema: {
              content: totalGroup.flat().map((item) => ({
                dataKey: item.value,
                label: item.title,
                formatValue: (value) => formatValueWithUnit({ value }),
              })),
            },
          }}
        >
          {totalGroup.map((group) => {
            const groupStackBarKeys = group.map((bar) => bar.value)
            return group.map((bar, barIndex) => (
              <Bar
                key={bar.value}
                yAxisId="left"
                dataKey={bar.value}
                fill={bar.color}
                stackId={bar.group}
                maxBarSize={25}
                showLabelEmpty={({ index }) =>
                  barIndex === 0 &&
                  groupStackBarKeys.every((dataKey) =>
                    isInValidValue(dataConvert[index][dataKey]),
                  )
                }
              />
            ))
          })}
        </ChartContainer>
      </div>
      <div className="h100 w40 px1 dFlex alignItemsCenter justifyContentCenter">
        <ScrollComponent>
          <span>
            {totalGroupCheck.map((group, idxGroup) => {
              return (
                <div key={idxGroup}>
                  <div
                    className="fw600"
                    style={{ marginTop: !idxGroup ? 0 : 6 }}
                  >
                    {renderGroupName(idxGroup + 1)}
                  </div>
                  {group.map((item) => {
                    return (
                      <div key={item.value} style={{ marginTop: 4 }}>
                        <LegendItem
                          chartId={chartId.current}
                          title={item.title}
                          value={item.value}
                          color={item.color}
                          dataKey={item.value}
                          isCheckbox={isCheckbox}
                          listCheckBox={checked}
                          setListCheckBox={setChecked}
                          style={{ marginLeft: 4 }}
                          isI18n={false}
                          isDynamicReport={isDynamicReport}
                        />
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </span>
        </ScrollComponent>
      </div>
    </div>
  )
}

export default Trend
